import { baseFetch } from "../api/baseFetch";
import { getUrlWithSearchParams } from "../common/helpres/link";
import { membersLink } from "../credentials/consts/links";
export var ApiCheckLogin;
(function (ApiCheckLogin) {
    ApiCheckLogin.get = () => {
        return baseFetch({
            method: "GET",
            url: getUrlWithSearchParams(`${membersLink}/extension/check-login`, {}),
            withCredentials: true,
        });
    };
})(ApiCheckLogin || (ApiCheckLogin = {}));
